module.exports = __webpack_public_path__ + "static/media/illustration_block.bf182e65.png";